import { Routes } from '@angular/router';
import { CurrencyAppComponent } from './currency-app.component';

export const CURRENCY_ROUTES: Routes = [
  {
    path: '',
    component: CurrencyAppComponent
  }
];
